import * as types from "../../mutation-types.js";
import http from "@service/http";
import util from "@common/utils/util";

const SCROLL_HEIGHT = "SCROLL_HEIGHT";
const GOOD_DATA = " GOOD_DATA";
const DIY_GOOD_DATA = " DIY_GOOD_DATA";
const GOOD_SKU = " GOOD_SKU";
const IS_SEL_SKU = " IS_SEL_SKU";
const SKUIMAGES = "SKUIMAGES";
const SELECT_INFO = "SELECT_INFO";
const GOODS_LISTS = "GOODS_LISTS";
const PAGENO = "PAGENO";
const LASTPAGE = "LASTPAGE";
/**
 * 分类 STORE
 */
export default {
  state: {
    scrollHeight: 0,
    goodData: {},
    diyGoodData: {},
    goodSku: {},
    isSelSku: {},
    skuImages: {},
    selectinfo: {},
    goodsLists: [],
    pageNo: 1,
    lastPage: 1,
  },
  actions: {
    //18.2.获取商品SKU信息
    getGoodsSkuMsg({ commit }, id) {
      return http
        .post({
          fn: "mallsale.goodsHandler.getGoodsSkuFields",
          param: id,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            let banners = result.target.target;
            return Promise.resolve(banners);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //18.3.通过选择属性 获取 商品单品信息
    getGoodsSku({ commit }, id) {
      return http
        .post({
          fn: "mallsale.goodsHandler.getGoodsSku",
          param: id,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            commit(GOOD_SKU, result.target.target);
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //18.4.获取商品详情
    getGoodsDetail({ commit }, id) {
      return http
        .post({
          fn: "mallsale.goodsHandler.getGoodsDetail",
          param: id,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //商品收藏
    addGoodsFav({ commit }, goodsId) {
      return http
        .post({
          fn: "mallsale.goodsFavHandler.addGoodsFav",
          param: [goodsId],
        })
        .then((result) => {
          if (result && result.success) {
            return Promise.resolve(result.target);
          } else {
            return Promise.reject((result && result.message) || "收藏失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //18.5.获取商品规格参数
    getGoodsKindValue({ commit }, id) {
      return http
        .post({
          fn: "mallsale. goodsHandler.getGoodsKindValue",
          param: id,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //13.2.加入购物车
    addMemCart({ commit }, data) {
      return http
        .post({
          fn: "mallsale.cartHandler.addMemCart",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            let res = result.target.target;
            return Promise.resolve(res);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //13.3.加入DIY商品到购物车
    addMemCartForDiy({ commit }, data) {
      return http
        .post({
          fn: "mallsale.cartHandler.addMemCartForDiy",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            let res = result.target.target;
            return Promise.resolve(res);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //15.2.直接购买-普通商品
    getOrderSettleMsg({ commit }, data) {
      return http
        .post({
          fn: "mallsale.settleHandler.getOrderSettleMsg",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            let res = result.target.target;
            return Promise.resolve(res);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //15.3.直接购买-DIY商品
    getOrderSettleMsgForDiy({ commit }, data) {
      return http
        .post({
          fn: "mallsale.settleHandler.getOrderSettleMsgForDiy",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            let banners = result.target.target;
            return Promise.resolve(banners);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //19.1.获取 Diy信息
    getDiyInfo({ commit }, data) {
      return http
        .post({
          fn: "mallsale.diyHandler.getDiyInfo",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            let banners = result.target.target;
            return Promise.resolve(banners);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //19.2.获取DIY 单品
    getDiySku({ commit }, data) {
      return http
        .post({
          fn: "mallsale.diyHandler.getDiySku",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            let banners = result.target.target;
            return Promise.resolve(banners);
          } else {
            return Promise.reject(util.getResultErrMsg(result));
          }
        })
        .catch((error) => {
          console.log("错误信息:", error);
          return Promise.reject(error);
        });
    },
    //获取搜索分类标签
    getGoodsPropertieTag({ commit }) {
      return http
        .post({
          fn: "mallsale.goodsHandler.getGoodsPropertieTag",
          param: [],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //23.2.获取 品牌列表
    getBrands({ commit }) {
      return http
        .post({
          fn: "mallsale.brandHandler.getBrands",
          param: [],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //获取排序列表
    getGoodsSearchSort({ commit }) {
      return http
        .post({
          fn: "mallsale.goodsSearchHandler.getGoodsSearchSort",
          param: [],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            commit(GOODS_HOTRANK_LISTS, result.target.target);
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    //17.2. 商品分页查询
    getPageGoods({ commit }, goodInfo) {
      commit(PAGENO, goodInfo[1]);
      return http
        .post({
          fn: "mallsale.goodsSearchHandler.pageGoods",
          param: goodInfo,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            commit(GOODS_LISTS, result.target.target.result);
            commit(LASTPAGE, result.target.target.lastPageNo);
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          result.reject(error);
        });
    },
    //11.7.获取商品评价总览
    getGoodsCommMsg({ commit }, goodsId) {
      return http
        .post({
          fn: "mallsale.commentHandler.getGoodsCommMsg",
          param: goodsId,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          result.reject(error);
        });
    },
    //24.1.随便获取商城N条广告
    randomAdver({ commit }, data) {
      return http
        .post({
          fn: "mallsale.advertHandler.randomAdver",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          result.reject(error);
        });
    },
    //24.1.随便获取商城N条广告
    randomStoreAdverts({ commit }, data) {
      return http
        .post({
          fn: "mallsale.storeHandler.randomStoreAdverts",
          param: data,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          result.reject(error);
        });
    },
    //11.8.分页查询商品评价
    pageGoodsCommMsg({ commit }, goodsId) {
      return http
        .post({
          fn: "mallsale.commentHandler.pageGoodsCommMsg",
          param: goodsId,
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取数据失败"
            );
          }
        })
        .catch((error) => {
          result.reject(error);
        });
    },

    //获取优惠券和红包列表
    getListStoreCoupons({ commit }, storeId) {
      return http
        .post({
          fn: "mallsale.couponHandler.listStoreCoupons",
          param: [storeId],
        })
        .then((result) => {
          if (
            result &&
            result.success &&
            result.target &&
            result.target.success
          ) {
            return Promise.resolve(result.target.target);
          } else {
            return Promise.reject(
              (result && (result.message || result.target.message)) ||
                "获取信息失败"
            );
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },
    //领取优惠券
    receiveCoupon({ commit }, couponInfo) {
      return http
        .post({
          fn: "mallsale.couponHandler.receiveCoupon",
          param: couponInfo,
        })
        .then((result) => {
          if (result && result.success) {
            return Promise.resolve(result.target);
          } else {
            return Promise.reject((result && result.message) || "领取失败");
          }
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    },

    savescrollHeight({ commit }, data) {
      commit(SCROLL_HEIGHT, data);
    },
    //保存要购买的商品信息
    saveGoodsData({ commit }, goodData) {
      commit(GOOD_DATA, goodData);
    },
    //DIY信息
    saveDiyData({ commit }, diyGoodData) {
      commit(DIY_GOOD_DATA, diyGoodData);
    },
    //弹框
    saveIsSelSku({ commit }, isSelSku) {
      commit(IS_SEL_SKU, isSelSku);
    },
    saveSelectSku({ commit }, data) {
      commit(SELECT_INFO, data);
    },
  },
  mutations: {
    [SCROLL_HEIGHT](state, data) {
      state.scrollHeight = data;
    },
    [GOOD_DATA](state, data) {
      state.goodData = data;
    },
    [DIY_GOOD_DATA](state, data) {
      state.diyGoodData = data;
    },
    [GOOD_SKU](state, data) {
      state.goodData.goodsSkuMsg.sku = data;
    },
    [SKUIMAGES](state, data) {
      state.goodData.skuImages = data;
    },
    [IS_SEL_SKU](state, data) {
      state.isSelSku = data;
    },
    [SELECT_INFO](state, selectinfo) {
      console.log(selectinfo.fieldId);
      let fieldValue = state.goodData.goodsSkuMsg.fields.find((item) => {
        return item.fieldId == selectinfo.fieldId;
      });
      fieldValue.values.forEach((item) => {
        if (item.valueId == selectinfo.valueId) {
          item.isChecked = 1;
        } else {
          item.isChecked = 0;
        }
      });
      //获取商品单品信息
      let values = [];
      state.goodData.goodsSkuMsg.fields.forEach((field) => {
        field.values.forEach((item) => {
          if (item.isChecked == 1) {
            if (item.isImage == 1) {
              state.goodData.skuImages = item.showImages;
            }
            let value = {
              fieldId: item.fieldId,
              valueId: item.valueId,
            };
            values.push(value);
          }
        });
      });
    },
    [GOODS_LISTS](state, goodsList) {
      if (state.pageNo == 1) {
        state.goodsLists = [];
      }

      state.goodsLists = state.goodsLists.concat(goodsList);
    },
    [PAGENO](state, pageNo) {
      state.pageNo = pageNo;
    },
    [LASTPAGE](state, last) {
      state.lastPage = last;
    },
  },
  getters: {
    scrollHeight: (state) => {
      return state.scrollHeight;
    },
    goodData: (state) => {
      return state.goodData;
    },
    skuImages: (state) => {
      return state.goodData.skuImages;
    },
    diyGoodData: (state) => {
      return state.diyGoodData;
    },
    goodSku: (state) => {
      return state.goodSku;
    },
    isSelSku: (state) => {
      return state.isSelSku;
    },
    goodsLists: (state) => {
      return state.goodsLists;
    },
    pageNo: (state) => {
      return state.pageNo;
    },
    lastPage: (state) => {
      return state.lastPage;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/classify/index.js